
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import { Loader } from '@googlemaps/js-api-loader'
import { OnMounted } from '~/core/vue.types'

const DEFAULT_TYPES = ['geocode']

@Component
export default class LocationField extends Vue implements OnMounted {
  @Prop({ required: false, default: false, type: Boolean })
  private readonly border!: boolean

  // TODO: Should the component be able to support few countries?
  @Prop({ required: true, default: '', type: String })
  readonly countryCode!: string

  @Prop({ required: false, default: () => DEFAULT_TYPES, type: Array })
  readonly types!: string[]

  private googleAPI!: typeof window.google
  private autocompleteInstance!: google.maps.places.Autocomplete

  get classList () {
    const base = 'location-field'
    return [
      base,
      {
        [`${base}--with-border`]: this.border,
      },
    ]
  }

  private get options (): google.maps.places.AutocompleteOptions {
    return {
      types: this.types,
      componentRestrictions: {
        country: [this.countryCode],
      },
    }
  }

  initAutocomplete () {
    const input = this.$refs?.autocompleteInput as HTMLInputElement
    this.autocompleteInstance = new this.googleAPI.maps.places.Autocomplete(input, this.options)
  }

  attachEventListener () {
    this.autocompleteInstance.addListener('place_changed', this.onPlaceChanged.bind(this))
  }

  @Emit()
  onPlaceChanged (): google.maps.places.PlaceResult {
    return this.getPlace()
  }

  getPlace () {
    return this.autocompleteInstance.getPlace()
  }

  async mounted () {
    const loader = new Loader({
      apiKey: this.$config.GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places'],
    })

    this.googleAPI = await loader.load()

    this.initAutocomplete()
    this.attachEventListener()
  }
}
